// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'

// todo
// cssVars()

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,  
  template: '<App/>',
  components: {
    App,    
  },
  created: function(){    
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname.substr(0,8) === "192.168."){
      Vue.prototype.$islocalhost = true
    } else{
      Vue.prototype.$islocalhost = false
    }    
  }  
})


/* test socket con laravel echo */
import LaravelEchoRepository from './repositories/LaravelEchoRepository'
LaravelEchoRepository.initBroadcast();

/* notifiche push  (init spostato in DefaultContainer) */ 
//import './repositories/PushNotificationRepository'

/* import FontAwesome */
import './repositories/FontAwesomeRepository'


/* Api Service */
import Axios from "./repositories/AxiosRepository"
Axios.init()
Vue.prototype.$apiService = Axios;

/* moment js */
import moment from 'vue-moment'
Vue.prototype.$moment = moment








